/**
 * Ustawienia kamery: na razie jedno — czy obrót przyciąga do krawędzi heksa.
 *
 * Osobny klucz i osobna sekcja menu, z tego samego powodu, z którego pogoda
 * nie siedzi w dźwięku: to są rzeczy, które nie mają ze sobą nic wspólnego
 * poza tym, że są ustawieniami.
 *
 * **Domyślnie przyciąga**, bo tak kamera działała od początku: sześć położeń,
 * w których siatka flat-top wygląda tak samo. Wyłączone zostawia kamerę pod
 * kątem, pod którym ją puszczono — za cenę siatki ustawionej ukośnie do ekranu.
 */

const STORAGE = 'winged.camera';

interface Camera {
  snap: boolean;
}

const DEFAULTS: Camera = { snap: true };

function stored(): Camera {
  try {
    const raw = localStorage.getItem(STORAGE);
    if (!raw) return { ...DEFAULTS };
    const saved = JSON.parse(raw) as Partial<Camera>;
    return { snap: saved.snap ?? DEFAULTS.snap };
  } catch {
    return { ...DEFAULTS };
  }
}

function save(camera: Camera): void {
  try {
    localStorage.setItem(STORAGE, JSON.stringify(camera));
  } catch {
    // Przełącznik działa dalej w tej sesji; nie ma o czym mówić.
  }
}

/** Czy obrót ma przyciągać do krawędzi, jak dziś zapisano. */
export function snapWanted(): boolean {
  return stored().snap;
}

/** Przełączniki kamery, jako jeden blok do menu. */
export function cameraSwitches(onSnap: (wanted: boolean) => void): HTMLElement {
  const camera = stored();

  const root = document.createElement('div');
  root.className = 'view-switches';

  const row = document.createElement('label');
  row.className = 'view-row';

  const box = document.createElement('input');
  box.type = 'checkbox';
  box.className = 'view-check';
  box.checked = camera.snap;

  const name = document.createElement('span');
  name.className = 'view-name';
  name.textContent = 'Przyciąganie obrotu';

  const hint = document.createElement('span');
  hint.className = 'view-hint';
  hint.textContent = 'po puszczeniu obrót staje na najbliższej krawędzi; wyłączone — dowolny kąt';

  box.addEventListener('change', () => {
    camera.snap = box.checked;
    onSnap(box.checked);
    save(camera);
  });

  row.append(box, name, hint);
  root.appendChild(row);
  return root;
}
